<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        modulInhalte: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Module content | Inhalte' : 'Inhalte'
    )

    const emit = defineEmits(['modulInhalteSaved'])

    let editModulInhalte = ref('')

    function handleEditStart() {
        editModulInhalte.value = props.modulInhalte
    }

    function handleEditAbort() {
        editModulInhalte.value = ''
    }

    const saveModulInhalte = () => {
        emit('modulInhalteSaved', editModulInhalte.value)
    }
</script>

<template>
    <common-single-edit
        :entry="modulInhalte"
        edit-key="modulInhalte"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveModulInhalte"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editModulInhalte" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="modulInhalte" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
